<template>
  <div class="black--text px-3">
    <div class="mx-5">
      <v-row class="subtitle-2 grey--text my-2"> Extra Options </v-row>

      <TemplateTextOption
        :type="type"
        :supplier="supplier"
        :products="products"
        :bookingSupplierMeta="metaconfig"
        @set-bsmeta="setBookingSupplierMeta"
      />
      <ParkingOption v-if="typeHotel" :supplier="supplier" :bsmeta="metaconfig" @set="setParking" />

      <div v-if="typeHotel" class="d-flex flex-row">
        <pcheck
          label="Custom Room List"
          :value="!!metaconfig.custom_room_num"
          @input="(v) => setBookingSupplierMeta({ key: 'custom_room_num', value: v ? {} : false })"
        />

        <RoomNumberField
          v-if="metaconfig.custom_room_num"
          :value="metaconfig.custom_room_num"
          :pax="pax_num"
          style="max-width: 130px"
          @input="(v) => setBookingSupplierMeta({ key: 'custom_room_num', value: v })"
          offmain
        />
      </div>
    </div>

    <v-row v-if="contacted" class="button-row" justify="space-between">
      <g-button label="Return" icon="reply" @onclick="$emit('close')" />
      <v-btn text disabled small>
        <span>contracted, cannot edit</span>
      </v-btn>
    </v-row>
    <div v-else>
      <v-row class="button-row py-3" justify="space-between">
        <g-button label="Cancel" icon="clear" @onclick="$emit('cancel')" />

        <div>
          <g-button label="Back" icon="keyboard_arrow_left" @onclick="$emit('revert')" />
          <g-button type="primary" label="Finished" :disabled="disableFinish" @onclick="onFinish" />
        </div>
      </v-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import TemplateTextOption from "./_TemplateTextOption";
import ParkingOption from "./_ParkingOption";

import { RoomNumberField } from "@/modules/bookings.rooms";

export default {
  props: {
    contacted: Boolean,
    init: Boolean, // When FIRST adding a booking supplier

    type: String,
    supplier: Object,
    products: Object,
    metaconfig: Object,
    disableFinish: Boolean,
  },
  components: {
    TemplateTextOption,
    ParkingOption,

    RoomNumberField,
  },
  data() {
    return {
      customRoom: false,
    };
  },
  computed: {
    pax_num() {
      return this.$store.getters["BookingStore/pax_num"] || this.$store.getters["BookingStore/data"]["est_pax_num"];
    },
    typeHotel() {
      return this.supplier.type_as === "HOTEL" || this.supplier.supplier_type === "HOTEL";
    },
  },
  methods: {
    // OPTIONS
    setBookingSupplierMeta({ key, value }) {
      Vue.set(this.metaconfig, key, value);
    },
    setParking(v) {
      Vue.set(this.metaconfig, "parking", v);
    },

    onFinish() {
      if (this.disableFinish) {
        this.$root.$error(
          "Duplicate room types in custom prices. Please fix highlighted room types before saving."
        );
        return;
      }
      this.$emit("finish");
    },

    // EJECT

    updatePricing() {
      // Data is saved to main (metaconfig) object thingy
      // xxxx Extract the results into reduced object for saving
      this.$emit("finish", false);
    },
  },
};
</script>

<style lang="scss">
.custom-price-row {
  border-bottom: 1px solid lightgrey;

  &:focus-within {
    color: #1976d2;
  }
}
</style>
